module.exports = __webpack_public_path__ + "img/clipboard-icon.7f60e453.svg";